import { CustomTag } from ".";

const CustomNavbarOption = ({ innerProps, isDisabled, label, subscriptions = [], ...props }) => {

    const customer = props.data;
    const isPremium = customer.supportInfo.isPremium;
    const isEssential = customer.supportInfo.isEssential;
    const isMutualized = customer.supportInfo.isMutualized;

    return (
        <>
            <div className="navbar-option-container">
                <div {...innerProps} className="c-badge-container">
                    <div className="navbar-customer-icon">
                        <img
                            src={customer.logo ? customer.logo : "https://image.store.altelis.com/images/altelis-tools/logo-altelis.png"}
                            alt="navbar-logo"
                        />
                    </div>
                    <div className="navbar-customer-info">
                        <span className="navbar-title">{customer.name}</span>
                        <div className="flex-gap-2">
                            <CustomTag 
                                value={isMutualized ? "Mutualisé" : (isPremium ? "Premium" : (isEssential ? "Essentiel" : "Aucun"))} 
                                className={`uppercase ${isMutualized ? "premium" : (isPremium ? "purple" : (isEssential ? "blue" : "deactivated"))}`} 
                            />
                            <div className="conso-wrapper">
                                <CustomTag 
                                    value={
                                        isMutualized 
                                            ? `${(customer.supportInfo.groupInfo?.totalGroupHours || 0).toFixed(1)}h / ${customer.supportInfo.groupInfo?.totalAvailableHours || customer.supportInfo.premiumHours || 0}h`
                                            : isPremium 
                                                ? `${(customer.supportHours || 0).toFixed(1)}h / ${customer.supportInfo.premiumHours || 0}h`
                                                : `${(customer.supportHours || 0).toFixed(1)}h`
                                    }
                                    className={
                                        isMutualized 
                                            ? ((customer.supportInfo.groupInfo?.totalGroupHours || 0) > (customer.supportInfo.groupInfo?.totalAvailableHours || customer.supportInfo.premiumHours || 0) ? "no-assistance" : "premium")
                                            : isPremium 
                                                ? ((customer.supportHours || 0) > (customer.supportInfo.premiumHours || 0) ? "no-assistance" : "success")
                                                : (customer.supportHours || 0) > 0 ? "no-assistance" : "success"
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="navbar-divider" />
        </>
    );
};

export default CustomNavbarOption;
